export type Provider = 'openai' | 'anthropic' | 'gemini';
export interface AdminUser { id: string; email: string; role: 'user' | 'admin'; status: 'active' | 'disabled' | 'pending'; createdAt?: string; emailVerifiedAt?: string | null; updatedAt?: string }
export interface AdminUserDetails {
  user: AdminUser & { createdAt: string; emailVerifiedAt: string | null; updatedAt: string };
  wallet: { balanceUnits: number; updatedAt: string; currency: 'CNY'; unit: '栀籽' } | null;
}
export interface AdminPagination { limit: number; offset: number; hasMore: boolean }
export type UserHistoryTab = 'Ledger' | 'Usage' | 'Orders';
export interface Model {
  id: string; slug: string; provider: Provider; protocol: 'openai-chat' | 'anthropic-messages' | 'gemini-generate' | 'openai-image';
  displayName: string; description: string; systemPrompt: string; systemPromptMode: 'override' | 'prepend'; capabilities: string[]; contextTokens: number; maxOutputTokens: number; isPublished: boolean; sortOrder: number;
}
export interface Channel { id: string; name: string; provider: Provider; purpose: 'chat' | 'image' | 'both'; baseUrl: string; timeoutMs: number; enabled: boolean }
export interface ModelRoute { id: string; modelId: string; upstreamId: string; upstreamModel: string; weight: number; enabled: boolean }
export interface Price { id: string; modelId: string; inputPerMillion: string; outputPerMillion: string; cachedInputPerMillion: string; cacheReadPerMillion?: string; image1k?: string; image2k?: string; image4k?: string; effectiveFrom: string; effectiveTo: string | null }
export interface TtsSettings {
  enabled: boolean; baseUrl: string; models: { preset: string; design: string; clone: string };
  timeoutMs: number; maxTextChars: number; maxReferenceBytes: number; temporaryTtlSeconds: number;
  maxDailyRequests: number;
}
export interface TtsResponse { settings: TtsSettings; apiKeyConfigured: boolean }
export interface AdminPlan {
  id: string;
  name: string;
  priceCents: number;
  durationDays: number;
  summary: string;
  tags: string[];
  description: string;
  capabilities: { autoText: boolean; autoImage: boolean; autoTts: boolean };
  quotaEnabled: boolean;
  textTokenQuota: number;
  imageQuota: number;
  ttsCharQuota: number;
  listed: boolean;
  sortOrder: number;
  archivedAt: string | null;
}
export type DataRow = Record<string, unknown> & { id: string };
export const ADMIN_TABS = ['Users', 'Plans', 'Vendors', 'Models', 'ImageModels', 'Channels', 'ImageChannels', 'ImageRoutes', 'Orders', 'Usage', 'Accounting', 'Ledger', 'Audit', 'TTS', 'Appearance', 'Operations', 'Security'] as const;
export type AdminTab = typeof ADMIN_TABS[number];
